import React from 'react'
import {connect} from 'react-redux'
import {createStructuredSelector} from 'reselect'

import * as nearestShowroomsSelectors from '../store/nearestShowrooms'
import {NearestShowroomLocation} from '../typedefs/showrooms'

import NearestShowroomLocationBanner from '../components/Landing/NearestShowroomLocationBanner'

interface Props {
  shouldDisplayNearestShowroomBanner: boolean
  nearestShowroomLocation?: NearestShowroomLocation
}

const NearestLocationBannerContainer: React.FC<Props> = ({
  nearestShowroomLocation,
  shouldDisplayNearestShowroomBanner,
}) =>
  shouldDisplayNearestShowroomBanner && nearestShowroomLocation ? (
    <NearestShowroomLocationBanner nearestShowroomLocation={nearestShowroomLocation} />
  ) : null

const mapStateToProps = createStructuredSelector({
  shouldDisplayNearestShowroomBanner: nearestShowroomsSelectors.shouldDisplayNearestShowroomBanner,
  nearestShowroomLocation: nearestShowroomsSelectors.nearestTheBlackTuxOrNordstromShowroom,
})

export default connect(mapStateToProps)(NearestLocationBannerContainer)
